import { useEffect } from "react";

import useTracker from "@/eventStream/useTracker";

const useTrackNativePrintEvents = () => {
  const { trackAction, getEventNameForEventStream } = useTracker();
  useEffect(() => {
    const trackBeforePrintEvent = () => {
      trackAction({
        event_name: getEventNameForEventStream(
          "FullPage",
          "Initiate",
          "Native Print",
        ),
        event_type: "native-interaction",
      });
    };
    globalThis.addEventListener("beforeprint", trackBeforePrintEvent);
    return () => {
      globalThis.removeEventListener("beforeprint", trackBeforePrintEvent);
    };
  }, [trackAction, getEventNameForEventStream]);
};

export default useTrackNativePrintEvents;
